// app/authService.ts

import { LoginResponse } from '@/models/auth.model'
import { ApiResponse } from '@/models/common.model'
import http from '@/utils/http'
import { LoginRequest, RegisterRequest } from '@/utils/schemas'

// Hàm gọi API login
export const login = async (credentials: LoginRequest): Promise<LoginResponse> => {
  return await http.post<LoginResponse>('/auth/sign-in', credentials)
}

// Hàm gọi API logout
// src/services/authService.ts

export const logout = async (): Promise<void> => {
  try {
    await http.post('/auth/sign-out')
  } catch (error) {
    throw new Error(`Lỗi khi đăng xuất ${error}`)
  }
}

// Hàm gọi API đăng ký
export const register = async (
  credentials: RegisterRequest
): Promise<ApiResponse<LoginResponse>> => {
  return await http.post<ApiResponse<LoginResponse>>('/auth/sign-up', credentials)
}
